<template>
  <div class="customer-detail">
    <div class="row">
      <div class="col-xs-12">
        <p-search placeholder="Buscar cliente por UC ..." @on-search="handleSearch($event)" class="input-group input-group-lg"/>
      </div>
    </div>

    <div class="row">
      <div class="col-md-8">
        <customer-card :customer="customer" v-loading="!customer._id" :showEditButton="false"/>
      </div>
      <div class="col-md-4">
        <customer-image-card
          :timestampImage="currentDate"
          :has-image="true"
          :customer="customer"
          v-loading="!customer._id"
          :showEditButton="false"
        />
      </div>
    </div>

    <div v-loading="!customer" style="min-height: 50px;">
      <div v-for="(ticket) in tickets" :key="ticket._id" class="row">
        <div class="col-lg-6 col-xs-12">
          <ticket-card
            v-loading="ticket.customer && ticket.event"
            @loadTicket="redirectToTicket(ticket)"
            :ticket="ticket"
            :event="ticket.event"
            :stock="ticket.stock"
          />
        </div>

        <div class="col-lg-6 col-xs-12">
          <event-card :event="ticket.event" :show-edit-button="false"/>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <lamps-list v-loading="loading" :customer="customer" :lamps="lamps"/>
      </div>
    </div>
  </div>
</template>

<script>
  import CustomerCard from 'src/pages/Customers/CustomerCard'
  import Couchdb from 'src/services/Couchdb'
  import CustomerImageCard from 'src/pages/Customers/CustomerImageCard'
  import EventCard from 'src/pages/Events/EventCard'
  import LampsList from 'src/pages/Lamps/ListLamps'
  import TicketCard from 'src/pages/Tickets/TicketCard'
  import {mapActions, mapGetters} from 'vuex'

  export default {
    name: 'customer-detail',
    components: {
      CustomerCard,
      CustomerImageCard,
      EventCard,
      TicketCard,
      LampsList
    },

    data () {
      return {
        currentDate: new Date().getTime()
      }
    },

    methods: {
      ...mapActions('customers', {
        fetchCustomerData: 'fetchCustomerDatas',
        resetCustomer: 'resetOne',
        getUrlImg: 'getUrlImg'
      }),

      async redirectToTicket (ticket) {
        this.$router.push({name: 'tickets.details', params: { id: ticket._id }})
      },

      handleSearch (event) {
        if (!event || event === '') {
          this.$notify({
            message: 'Digite uma UC no campo de busca',
            type: 'info'
          })
        } else {
          this.resetCustomer()
          Couchdb.viewQueries({
            connection: 'default',
            ddoc: 'customers-by-uc',
            view: 'customers-by-uc',
            queries: [{key: event}]
          })
            .then(response => {
              this.fetchCustomerData({id: response[0].rows[0].id})
            })
        }
      },

      getDatas () {
        this.resetCustomer()
        this.fetchCustomerData({id: this.customerId})
      }
    },
    computed: {
      ...mapGetters('customers', {
        customer: 'customer',
        loading: 'loading'
      }),

      tickets () {
        return this.customer && this.customer.hasOwnProperty('tickets') ? this.customer.tickets : []
      },

      lamps () {
        if (this.customer && this.customer.hasOwnProperty('lamps')) {
          let items = []
          for (let indx in this.customer.lamps) {
            for (let item of this.customer.lamps[indx].items) {
              item.userId = this.customer.lamps[indx].userId
              items.push(item)
            }
          }

          return items
        } else {
          return []
        }
      },

      customerId () {
        return this.$route.params.id
      }
    },
    mounted () {
      this.currentDate = new Date().getTime()
      this.getUrlImg({id: this.customerId})
      this.getDatas()
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Customers/CustomerDetail.vue